import { useMemo } from "react";
import { usePmsTheme } from "../Components/PmsThemeContext";
import { createReservationTranslator } from "./reservationI18n";

export const guestProfileMessages = {
  "Guest Profile": "Perfil del huésped",
  "Required fields are marked with an asterisk.": "Los campos obligatorios están marcados con un asterisco.",
  "The profile will be assigned immediately after saving.": "El perfil se asignará inmediatamente después de guardar.",
  "Close guest profile": "Cerrar perfil del huésped",
  "{count} required": "{count} obligatorios",
  "Removing...": "Quitando...",
  "Saving...": "Guardando...",
  "Save changes": "Guardar cambios",
  "Edit Booker": "Editar titular de la reserva",
  "Create Booker": "Crear titular de la reserva",
  "Update the person or company responsible for booking this reservation group.": "Actualiza la persona o empresa responsable de este grupo de reservas.",
  "Create a person or company profile and assign it directly as the reservation booker.": "Crea el perfil de una persona o empresa y asígnalo como titular de la reserva.",
  "Company booker": "Empresa titular de la reserva",
  "Person booker": "Persona titular de la reserva",
  "Create booker": "Crear titular de la reserva",
  "Remove booker": "Quitar titular de la reserva",
  "Edit Main Guest": "Editar huésped principal",
  "Create Main Guest": "Crear huésped principal",
  "Update the selected main guest details while keeping the reservation assignment in sync.": "Actualiza los datos del huésped principal manteniendo su asignación a la reserva.",
  "Create a new guest profile and assign it directly as the main guest of the reservation.": "Crea un perfil y asígnalo como huésped principal de la reserva.",
  "Main guest details": "Datos del huésped principal",
  "New reservation main guest": "Nuevo huésped principal de la reserva",
  "Create main guest": "Crear huésped principal",
  "Remove main guest": "Quitar huésped principal",
  "Edit Accompanying Guest": "Editar acompañante",
  "Create Accompanying Guest": "Crear acompañante",
  "Update the selected accompanying guest details without altering the assigned slot.": "Actualiza los datos del acompañante sin cambiar su plaza asignada.",
  "Create a new guest profile and assign it to the selected accompanying slot.": "Crea un perfil y asígnalo a la plaza de acompañante seleccionada.",
  "Accompanying guest details": "Datos del acompañante",
  "New accompanying guest": "Nuevo acompañante",
  "Create accompanying guest": "Crear acompañante",
  "Remove accompanying guest": "Quitar acompañante",
  "Edit Child Guest": "Editar huésped infantil",
  "Create Child Guest": "Crear huésped infantil",
  "Update the selected child guest details while preserving the current child slot.": "Actualiza los datos del huésped infantil manteniendo su plaza asignada.",
  "Create a new guest profile and assign it directly to the selected child slot.": "Crea un perfil y asígnalo a la plaza infantil seleccionada.",
  "Child guest details": "Datos del huésped infantil",
  "New child guest": "Nuevo huésped infantil",
  "Create child guest": "Crear huésped infantil",
  "Remove child guest": "Quitar huésped infantil",
  "Missing reservation id.": "No se encuentra el identificador de la reserva.",
  "Missing customer id for edit.": "No se encuentra el identificador del cliente que quieres editar.",
  "Customer created but no id returned.": "Se ha creado el cliente, pero no se ha recibido su identificador.",
  "Missing guest slot (guest_index).": "No se ha seleccionado la plaza del huésped.",
  "Missing reservation id or customer id.": "No se encuentra el identificador de la reserva o del cliente.",
  "Error saving main guest. Please try again.": "No se ha podido guardar el huésped principal. Inténtalo de nuevo.",
  "Error removing main guest. Please try again.": "No se ha podido quitar el huésped principal. Inténtalo de nuevo.",
  "Error saving accompanying guest.": "No se ha podido guardar el acompañante.",
  "Error removing accompanying guest.": "No se ha podido quitar el acompañante.",
  "Error saving child.": "No se ha podido guardar el huésped infantil.",
  "Error removing child.": "No se ha podido quitar el huésped infantil.",
  "Complete the required fields: {fields}.": "Completa los campos obligatorios: {fields}.",
  "Missing required fields: {fields}": "Faltan campos obligatorios: {fields}",
  "The full company profile could not be loaded. Close this window and reopen it before saving to protect the existing profile details.": "No se ha podido cargar el perfil completo de la empresa. Cierra esta ventana y vuelve a abrirla antes de guardar para proteger los datos existentes.",
  "The full guest profile could not be loaded. Close this window and reopen it before saving to protect the existing profile details.": "No se ha podido cargar el perfil completo del huésped. Cierra esta ventana y vuelve a abrirla antes de guardar para proteger los datos existentes.",
  "The reservation group is missing. Close this window and reopen the booker flow.": "No se encuentra el grupo de reservas. Cierra esta ventana y vuelve a abrir la selección del titular.",
  "The business unit is missing. Close this window and reopen the booker flow.": "No se encuentra la unidad de negocio. Cierra esta ventana y vuelve a abrir la selección del titular.",
  "Enter the company name.": "Introduce el nombre de la empresa.",
  "A company must be active to be assigned as a booker. Change its status to Active before saving.": "La empresa debe estar activa para ser titular de la reserva. Cambia su estado a Activa antes de guardar.",
  "Enter the full name of the person who contacted you to book for this company.": "Introduce el nombre completo de la persona que contactó para reservar en nombre de esta empresa.",
  "The booker could not be saved. Please try again.": "No se ha podido guardar el titular de la reserva. Inténtalo de nuevo.",
  "The booker could not be removed. Please try again.": "No se ha podido quitar el titular de la reserva. Inténtalo de nuevo.",
  "The guest profiles could not be loaded.": "No se han podido cargar los perfiles de los huéspedes.",
  "The company profiles could not be loaded.": "No se han podido cargar los perfiles de las empresas.",
  "Select a company first.": "Selecciona primero una empresa.",
  "Select a person first.": "Selecciona primero una persona.",
  "The reservation booker selection is unavailable.": "La selección del titular de la reserva no está disponible.",
  "The booker could not be assigned. Please try again.": "No se ha podido asignar el titular de la reserva. Inténtalo de nuevo.",
  "Select Booker": "Seleccionar titular de la reserva",
  "Choose a person or company to book this reservation group.": "Elige la persona o empresa titular de este grupo de reservas.",
  "Search the customer catalog, then select a profile to assign.": "Busca en el catálogo de clientes y selecciona el perfil que quieres asignar.",
  "Assign booker": "Asignar titular de la reserva",
  "The selected profile will be assigned to this reservation group.": "El perfil seleccionado se asignará a este grupo de reservas.",
  "Search companies": "Buscar empresas",
  "Search people": "Buscar personas",
  "Name, tax ID, email or phone": "Nombre, identificación fiscal, correo o teléfono",
  "Name, email, phone or document": "Nombre, correo, teléfono o documento",
  "Selected:": "Seleccionado:",
  "Retry": "Reintentar",
  "Loading profiles...": "Cargando perfiles...",
  "No companies found. Use Add booker to create a new profile.": "No se han encontrado empresas. Usa Añadir titular para crear un perfil.",
  "No people found. Use Add booker to create a new profile.": "No se han encontrado personas. Usa Añadir titular para crear un perfil.",
  "Unnamed guest": "Huésped sin nombre",
  "No contact details": "Sin datos de contacto",
  "Selected": "Seleccionado",
  "Showing the first 100 matches. Refine your search to find another company.": "Se muestran las primeras 100 coincidencias. Refina la búsqueda para encontrar otra empresa.",
  "Company details": "Datos de la empresa",
  "Company name": "Nombre de la empresa",
  "Legal name": "Razón social",
  "Tax / VAT ID": "Identificación fiscal / IVA",
  "Registration number": "Número de registro",
  "Website": "Sitio web",
  "Industry": "Sector",
  "Company type": "Tipo de empresa",
  "Company address": "Dirección de la empresa",
  "Region / State": "Provincia / Estado",
  "Postal code": "Código postal",
  "Billing details": "Datos de facturación",
  "Billing email": "Correo de facturación",
  "Billing address": "Dirección de facturación",
  "Billing city": "Ciudad de facturación",
  "Billing region / State": "Provincia / Estado de facturación",
  "Billing postal code": "Código postal de facturación",
  "Billing country": "País de facturación",
  "Booker customer type": "Tipo de titular de la reserva",
  "Person": "Persona",
  "Company": "Empresa",
  "Reservation contact": "Contacto de la reserva",
  "The person who called or contacted you to book on behalf of the company. This contact belongs to this reservation group and is not assigned as a guest.": "La persona que llamó o contactó para reservar en nombre de la empresa. Este contacto pertenece al grupo de reservas y no se asigna como huésped.",
  "Contact person full name": "Nombre completo de la persona de contacto",
  " (optional)": " (opcional)",
  "First and last name": "Nombre y apellidos",
  "Additional information": "Información adicional",
  "Status": "Estado",
  "Active": "Activa",
  "Inactive": "Inactiva",
  "Notes": "Notas",
  "Select Guest": "Seleccionar huésped",
  "Search and select any guest by name, email, country, phone or document.": "Busca y selecciona un huésped por nombre, correo, país, teléfono o documento.",
  "Guest Directory": "Directorio de huéspedes",
  "Search guests": "Buscar huéspedes",
  "Search by name, email, country, phone or document": "Buscar por nombre, correo, país, teléfono o documento",
  "Loading guests...": "Cargando huéspedes...",
  "Loading": "Cargando",
  "{count} result": "{count} resultado",
  "{count} results": "{count} resultados",
  "No guests match your search.": "No hay huéspedes que coincidan con la búsqueda.",
  "No guests found.": "No se han encontrado huéspedes.",
  "Name": "Nombre",
  "Action": "Acción",
  "Use the search bar to quickly filter the full guest list.": "Usa el buscador para filtrar la lista completa de huéspedes.",
  "Failed to select customer.": "No se ha podido seleccionar el cliente.",
  "Gender": "Género",
  "Male": "Masculino",
  "Female": "Femenino",
  "Other": "Otro",
  "Undisclosed": "No indicado",
  "Salutation": "Tratamiento",
  "Mr": "Sr.", "Mrs": "Sra.", "Ms": "Sra.", "Mx": "Tratamiento neutro",
  "First Name": "Nombre",
  "Middle Name": "Segundo nombre",
  "Last Name": "Primer apellido",
  "Second Last Name": "Segundo apellido",
  "ID Type": "Tipo de documento",
  "Passport": "Pasaporte",
  "ID Card": "Documento de identidad",
  "Driving License": "Permiso de conducir",
  "ID Number": "Número de documento",
  "Email": "Correo electrónico",
  "Phone": "Teléfono",
  "Birth Date": "Fecha de nacimiento",
  "Address": "Dirección",
  "Postal Code": "Código postal",
  "City": "Ciudad",
  "Country": "País",
  "Is VIP": "Es VIP",
  "Level": "Nivel",
  "Photo URL": "URL de la foto",
  "To add a valid photo:\\n1. Click 'Search in Internet'\\n2. Right-click the image\\n3. Open image in new tab\\n4. Copy that URL\\n5. Paste it here": "Para añadir una foto válida:\n1. Pulsa «Buscar en Internet»\n2. Haz clic derecho en la imagen\n3. Abre la imagen en una pestaña nueva\n4. Copia su URL\n5. Pégala aquí",
  "How to insert a valid photo URL:\n1. Click 'Search in Internet'\n2. Find an image\n3. Right-click\n4. Open image in new tab\n5. Copy that URL and paste here": "Cómo introducir una URL de foto válida:\n1. Pulsa «Buscar en Internet»\n2. Busca una imagen\n3. Haz clic derecho\n4. Abre la imagen en una pestaña nueva\n5. Copia su URL y pégala aquí",
  "Search in Internet": "Buscar en Internet",
  "Enter a name": "Introduce un nombre",
  "Customer Description": "Descripción del cliente",
  "Required for VIPs": "Obligatorio para clientes VIP",
  "Optional notes about this customer": "Notas opcionales sobre este cliente",
  "Customer": "Cliente",
  "No options": "Sin opciones",
  "❌ This customer is too young to be considered an adult.\nCurrent age: {age} years": "❌ Este cliente no tiene edad suficiente para considerarse adulto.\nEdad actual: {age} años",
  "❌ The age for a child must be between {min} and {max}.\nCurrent age: {age}": "❌ La edad de un niño debe estar entre {min} y {max} años.\nEdad actual: {age}",
};

const FIELD_LABELS = {
  first_name: "First Name", middle_name: "Middle Name", last_name: "Last Name", second_last_name: "Second Last Name",
  salutation: "Salutation", gender: "Gender", birth_date: "Birth Date", email: "Email", phone: "Phone",
  country: "Country", city: "City", address: "Address", postal_code: "Postal Code", document_type: "ID Type",
  document_number: "ID Number", is_vip: "Is VIP", vip_level: "Level", customer_description: "Customer Description",
  photo_url: "Photo URL", name: "Company name", booker_contact_name: "Contact person full name", status: "Status",
};

export function useGuestProfileLanguage() {
  const { languageId } = usePmsTheme();
  const t = useMemo(() => createReservationTranslator(languageId, guestProfileMessages), [languageId]);
  return { languageId, t };
}

export function formatGuestProfileFeedback(feedback, languageId) {
  const t = createReservationTranslator(languageId, guestProfileMessages);
  if (!feedback) return "";
  if (typeof feedback === "object") {
    const fields = (feedback.fields || []).map((field) => languageId === "es" ? t(FIELD_LABELS[field] || field.replace(/_/g, " ")) : field).join(", ");
    return t(feedback.key, { ...feedback.values, fields });
  }
  const translated = t(feedback);
  if (languageId !== "es" || translated !== feedback || Object.prototype.hasOwnProperty.call(guestProfileMessages, feedback)) return translated;
  return "No se ha podido completar la operación. Revisa los datos e inténtalo de nuevo.";
}

const COUNTRY_CODES = "AF AL DZ AD AO AR AM AU AT AZ BS BH BD BB BY BE BZ BJ BT BO BA BW BR BN BG BF BI KH CM CA CV CF TD CL CN CO KM CR HR CU CY CZ DK DJ DM DO EC EG SV EE SZ ET FJ FI FR GA GM GE DE GH GR GD GT GN GW GY HT HN HU IS IN ID IR IQ IE IL IT JM JP JO KZ KE KI KW KG LA LV LB LS LR LY LI LT LU MG MW MY MV ML MT MH MR MU MX FM MD MC MN ME MA MZ MM NA NR NP NL NZ NI NE NG KP MK NO OM PK PW PA PG PY PE PH PL PT QA RO RU RW KN LC VC WS SM ST SA SN RS SC SL SG SK SI SB SO ZA KR SS ES LK SD SR SE CH SY TW TJ TZ TH TL TG TO TT TN TR TM TV UG UA AE GB US UY UZ VU VA VE VN YE ZM ZW".split(" ");
const COUNTRY_ALIASES = {
  "Cape Verde": "CV", "Czech Republic": "CZ", "East Timor": "TL", "Micronesia": "FM", "Vatican City": "VA", "Turkey": "TR",
  "Bosnia and Herzegovina": "BA", "Myanmar": "MM", "Saint Kitts and Nevis": "KN", "Saint Lucia": "LC",
  "Saint Vincent and the Grenadines": "VC", "Sao Tome and Principe": "ST", "Trinidad and Tobago": "TT",
};
let countryLabels;

export function getGuestCountryLabel(country, languageId) {
  if (languageId !== "es" || !country || typeof Intl.DisplayNames !== "function") return country;
  if (!countryLabels) {
    const english = new Intl.DisplayNames(["en"], { type: "region" });
    const spanish = new Intl.DisplayNames(["es"], { type: "region" });
    countryLabels = Object.fromEntries(COUNTRY_CODES.flatMap((code) => [[english.of(code), spanish.of(code)], [code, spanish.of(code)]]));
    Object.entries(COUNTRY_ALIASES).forEach(([name, code]) => { countryLabels[name] = spanish.of(code); });
  }
  return countryLabels[country] || country;
}
